import {action, observable, makeObservable} from "mobx";

export class PopupStore {
    disabled: boolean;
    selected: string | undefined;
    visible: boolean;
    constructor() {
        makeObservable(this, {
            disabled: observable,
            selected: observable,
            visible: observable,

            setDisabled: action,
            setSelected: action,
            setVisible: action
        });
        this.setDisabled(false);
        this.setVisible(false);
    }
    setDisabled(disabled: boolean) {
        this.disabled = disabled;
    }
    setSelected(selected?: string) {
        this.selected = selected;
    }
    setVisible(visible: boolean) {
        this.visible = visible;
        if(!visible){
            this.setSelected();
        }
    }
}
